(function () {
  function moneyFormatter(currencyCode) {
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currencyCode || 'GBP',
      });
    } catch (error) {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
      });
    }
  }

  function starMarkup(rating, size) {
    var html = '';
    var starSize = size || 18;
    var whole = Math.floor(rating);
    var hasHalf = rating - whole >= 0.5;
    var i;

    for (i = 0; i < 5; i += 1) {
      if (i < whole) {
        html += '<svg width="' + starSize + '" height="' + starSize + '" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
      } else if (i === whole && hasHalf) {
        html += '<svg width="' + starSize + '" height="' + starSize + '" viewBox="0 0 24 24"><defs><linearGradient id="half-star-' + i + '-' + starSize + '"><stop offset="50%" stop-color="currentColor"></stop><stop offset="50%" stop-color="var(--border)"></stop></linearGradient></defs><path fill="url(#half-star-' + i + '-' + starSize + ')" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
      } else {
        html += '<svg width="' + starSize + '" height="' + starSize + '" viewBox="0 0 24 24"><path fill="var(--border)" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
      }
    }

    return html;
  }

  function colorSwatch(value) {
    var key = String(value || '').trim().toLowerCase();
    var map = {
      black: '#1c1c1c',
      white: '#f3f1eb',
      cream: '#efe6d3',
      grey: '#8d9095',
      gray: '#8d9095',
      silver: '#b7bcc3',
      charcoal: '#474b51',
      beige: '#d6c3a5',
      sand: '#ccb58f',
      taupe: '#9c8472',
      mink: '#8d7466',
      brown: '#6c4d37',
      blue: '#55728a',
      navy: '#24364e',
      green: '#5f7a5a',
      olive: '#68704f',
      pink: '#d0a1a1',
      blush: '#d7b0ad',
      mustard: '#be9139',
      gold: '#c3a25d',
      teal: '#3a6b6e',
      red: '#a84842',
      plum: '#6f4b62',
      stone: '#b6ada2',
      natural: '#d9c9a5',
      'light grey': '#b7bcc3',
      'dark grey': '#5a5d63',
      'light gray': '#b7bcc3',
      'dark gray': '#5a5d63',
      'dark blue': '#1e3a5f',
      'light blue': '#8faabe',
      'dark green': '#3d5a3a',
      'light green': '#8fb08c',
      'dark brown': '#3e2a1a',
      'light brown': '#a68b6b',
      'off white': '#f0ebe0',
      ivory: '#f5f0e1',
      'slate grey': '#6b7b8d',
      'slate gray': '#6b7b8d',
      'warm grey': '#9e9186',
      'warm gray': '#9e9186',
      'cool grey': '#8e9bae',
      'cool gray': '#8e9bae',
      'pewter': '#8b8d91',
      'mocha': '#7a6053',
      'espresso': '#4a3228',
      'walnut': '#6b4e37',
      'oak': '#a0784e',
      'pine': '#c4a35a',
      'cherry': '#7b2230',
      mahogany: '#5e2028',
      'cognac': '#8a4520',
      rust: '#a64428',
      terracotta: '#c4613a',
      'duck egg': '#9ec5c5',
      sage: '#8fa888',
      'forest green': '#3d6b4a',
      'ocean blue': '#4a7a9b',
      'midnight blue': '#1c2951',
      'petrol blue': '#2d5f6e',
      aubergine: '#5b3a52',
      lavender: '#a48bb8',
      copper: '#b46841',
      bronze: '#9b6b3a',
      'rose gold': '#c48b82',
      cognac: '#8a4520',
    };

    // Try exact match first
    if (map[key]) {
      return { type: 'hex', value: map[key] };
    }

    // Try partial match - check if the key contains a known color
    var colorNames = Object.keys(map);
    for (var i = 0; i < colorNames.length; i++) {
      if (key.indexOf(colorNames[i]) !== -1 || colorNames[i].indexOf(key) !== -1) {
        return { type: 'hex', value: map[colorNames[i]] };
      }
    }

    return { type: 'none', value: '' };
  }

  function buildVariantLabel(variant, optionNames) {
    return optionNames
      .map(function (name, index) {
        var value = variant.options[index];
        if (!value || value === 'Default Title') {
          return '';
        }

        return value;
      })
      .filter(Boolean)
      .join(', ');
  }

  function updateCartBadges() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('.cart-badge').forEach(function (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {
        return null;
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-stilloak-product]');
    var dataNode;
    var context;
    var formatter;
    var product;
    var mediaById = {};
    var selectedOptions = [];
    var currentVariant = null;
    var selectedUpsell = null;
    var appliedDiscountCode = localStorage.getItem('stilloak_discount_code') || '';

    if (!root) {
      return;
    }

    dataNode = root.querySelector('[data-product-context]');
    if (!dataNode) {
      return;
    }

    context = JSON.parse(dataNode.textContent);
    formatter = moneyFormatter(context.currencyCode);
    product = context.product;

    context.media.forEach(function (media) {
      mediaById[String(media.id)] = media;
    });

    currentVariant = context.variants.find(function (variant) {
      return Number(variant.id) === Number(context.selectedVariantId);
    }) || context.variants[0];

    selectedOptions = currentVariant ? currentVariant.options.slice() : [];
    var filteredMediaIds = [];
    var currentGalleryIndex = 0;

    var elements = {
      productBadges: root.querySelector('[data-product-badges]'),
      title: root.querySelector('[data-product-title]'),
      mainImage: root.querySelector('[data-main-image]') || root.querySelector('.main-image img'),
      thumbnailList: root.querySelector('[data-thumbnail-list]'),
      stars: root.querySelector('[data-rating-stars]'),
      ratingValue: root.querySelector('[data-rating-value]'),
      reviewCount: root.querySelector('[data-review-count]'),
      originalPrice: root.querySelector('[data-original-price]'),
      salePrice: root.querySelector('[data-sale-price]'),
      saveAmount: root.querySelector('[data-save-amount]'),
      hiddenVariantInput: root.querySelector('[data-variant-input]'),
      qtyInput: root.querySelector('[data-quantity-input]'),
      qtyDecrease: root.querySelector('[data-qty-decrease]'),
      qtyIncrease: root.querySelector('[data-qty-increase]'),
      addToCart: root.querySelector('[data-add-to-cart]'),
      buyNow: root.querySelector('[data-buy-now]'),
      stickyPurchase: root.querySelector('[data-sticky-purchase]'),
      stickyImage: root.querySelector('[data-sticky-image]') || root.querySelector('.sticky-product-info img'),
      stickyTitle: root.querySelector('[data-sticky-title]'),
      stickyVariant: root.querySelector('[data-sticky-variant]'),
      stickyPrice: root.querySelector('[data-sticky-price]'),
      stickyUpsell: root.querySelector('[data-sticky-upsell]'),
      stickyAdd: root.querySelector('[data-sticky-add]'),
      zoomButton: root.querySelector('[data-zoom-button]'),
      zoomOverlay: root.querySelector('[data-zoom-overlay]'),
      zoomImage: root.querySelector('[data-zoom-image]'),
      readMoreButton: root.querySelector('[data-read-more-button]'),
      descFull: root.querySelector('[data-description-full]'),
      voucherInput: root.querySelector('[data-voucher-input]'),
      voucherButton: root.querySelector('[data-voucher-button]'),
      voucherMessage: root.querySelector('[data-voucher-message]'),
      wishlistButton: root.querySelector('[data-wishlist-button]'),
      compareButton: root.querySelector('[data-compare-button]'),
      upsellGrid: root.querySelector('[data-upsell-grid]'),
      selectedUpsellText: root.querySelector('[data-selected-upsell]'),
      selectedUpsellPrice: root.querySelector('[data-selected-upsell-price]'),
      clearUpsell: root.querySelector('[data-clear-upsell]'),
      mattressInlineCards: root.querySelector('[data-mattress-inline-cards]'),
      mattressInlineFooter: root.querySelector('[data-mattress-inline-footer]'),
      mattressSelectedName: root.querySelector('[data-mattress-selected-name]'),
      mattressSelectedPrice: root.querySelector('[data-mattress-selected-price]'),
      mattressSizeLabelInline: root.querySelector('[data-mattress-size-label-inline]'),
      reviewRatingBig: root.querySelector('[data-review-rating-big]'),
      reviewStarsLarge: root.querySelector('[data-review-stars-large]'),
      reviewTotalCount: root.querySelector('[data-review-total-count]'),
      reviewHighlight: root.querySelector('[data-review-highlight]'),
      reviewHighlightAuthor: root.querySelector('[data-review-highlight-author]'),
      reviewsList: root.querySelector('[data-reviews-list]'),
      galleryPrev: root.querySelector('[data-gallery-prev]'),
      galleryNext: root.querySelector('[data-gallery-next]'),
      thumbPrev: root.querySelector('[data-thumb-prev]'),
      thumbNext: root.querySelector('[data-thumb-next]'),
    };

    function isColorOption(optionName) {
      var name = String(optionName || '').toLowerCase();
      return name.indexOf('color') !== -1 || name.indexOf('colour') !== -1;
    }

    /* ── Size option helpers ── */

    function getSizeOptionIndex() {
      var idx = -1;
      (context.optionNames || []).forEach(function (name, i) {
        var n = name.toLowerCase();
        if (n.indexOf('size') !== -1) {
          idx = i;
        }
      });
      if (idx === -1) {
        (context.optionNames || []).forEach(function (name, i) {
          if (!isColorOption(name) && idx === -1) {
            idx = i;
          }
        });
      }
      return idx;
    }

    var sizeOptionIndex = getSizeOptionIndex();

    function getSelectedSize() {
      if (sizeOptionIndex === -1) return '';
      return (selectedOptions[sizeOptionIndex] || '').trim().toLowerCase();
    }

    function findMattressSizeOptionIndex(mp) {
      var idx = -1;
      (mp.options || []).forEach(function (opt, i) {
        var n = (opt.name || '').toLowerCase();
        if (n.indexOf('size') !== -1) {
          idx = i;
        }
      });
      if (idx === -1) {
        (mp.options || []).forEach(function (opt, i) {
          var n = (opt.name || '').toLowerCase();
          if (n.indexOf('color') === -1 && n.indexOf('colour') === -1 && idx === -1) {
            idx = i;
          }
        });
      }
      return idx;
    }

    /* ── Core functions ── */

    function getCurrentMedia() {
      var mediaId = context.selectedMediaId ? String(context.selectedMediaId) : '';
      if (!mediaId && currentVariant && currentVariant.featuredMediaId) {
        mediaId = String(currentVariant.featuredMediaId);
      }
      return mediaById[mediaId] || context.media[0] || null;
    }

    function getCurrentQuantity() {
      var quantity = parseInt(elements.qtyInput.value, 10) || 1;
      return Math.max(1, Math.min(10, quantity));
    }

    function getUpsellPrice() {
      if (!selectedUpsell) {
        return 0;
      }

      return selectedUpsell.price;
    }

    function totalPrice() {
      var base = currentVariant ? currentVariant.price : 0;
      return (base + getUpsellPrice()) * getCurrentQuantity();
    }

    function preloadImage(src) {
      var img = new Image();
      img.src = src;
    }

    function preloadAllMedia() {
      context.media.forEach(function (m) {
        preloadImage(m.src);
      });
    }

    function updateMainImage(mediaId) {
      var media = mediaById[String(mediaId)] || context.media[0];
      if (!media || !elements.mainImage) {
        return;
      }

      elements.mainImage.src = media.src;
      elements.mainImage.removeAttribute('srcset');
      elements.mainImage.alt = media.alt || product.title;

      if (elements.stickyImage) {
        elements.stickyImage.src = media.src;
        elements.stickyImage.removeAttribute('srcset');
        elements.stickyImage.alt = media.alt || product.title;
      }

      if (elements.zoomImage) {
        elements.zoomImage.src = media.src;
      }

      elements.thumbnailList.querySelectorAll('.thumbnail:not(.hidden-by-color)').forEach(function (thumbnail) {
        thumbnail.classList.toggle('active', thumbnail.getAttribute('data-media-id') === String(media.id));
      });

      var idx = filteredMediaIds.indexOf(String(media.id));
      if (idx !== -1) {
        currentGalleryIndex = idx;
      }

      // Preload adjacent images for smooth navigation
      if (filteredMediaIds.length > 1) {
        var nextIdx = (currentGalleryIndex + 1) % filteredMediaIds.length;
        var prevIdx = (currentGalleryIndex - 1 + filteredMediaIds.length) % filteredMediaIds.length;
        var nextMedia = mediaById[filteredMediaIds[nextIdx]];
        var prevMedia = mediaById[filteredMediaIds[prevIdx]];
        if (nextMedia) preloadImage(nextMedia.src);
        if (prevMedia) preloadImage(prevMedia.src);
      }
    }

    function updateBadges() {
      var markup = '';
      var discount = 0;

      if (!currentVariant) {
        return;
      }

      if (currentVariant.compareAtPrice > currentVariant.price) {
        discount = Math.round(((currentVariant.compareAtPrice - currentVariant.price) / currentVariant.compareAtPrice) * 100);
        markup += '<span class="sale-badge">Save ' + discount + '%</span>';
      }

      if (context.isNew) {
        markup += '<span class="new-badge">New</span>';
      }

      markup += '<span class="stock-badge ' + (currentVariant.available ? 'in-stock' : 'out-stock') + '">' + (currentVariant.available ? 'In Stock' : 'Out of Stock') + '</span>';
      elements.productBadges.innerHTML = markup;
    }

    function updatePriceDisplay() {
      if (!currentVariant) {
        return;
      }

      if (currentVariant.compareAtPrice > currentVariant.price) {
        elements.originalPrice.textContent = formatter.format(currentVariant.compareAtPrice / 100);
        elements.originalPrice.style.display = '';
        elements.saveAmount.textContent = 'Save ' + formatter.format((currentVariant.compareAtPrice - currentVariant.price) / 100);
        elements.saveAmount.style.display = '';
      } else {
        elements.originalPrice.textContent = '';
        elements.originalPrice.style.display = 'none';
        elements.saveAmount.textContent = '';
        elements.saveAmount.style.display = 'none';
      }

      elements.salePrice.textContent = formatter.format(currentVariant.price / 100);
      elements.stickyPrice.textContent = formatter.format(totalPrice() / 100);

      if (selectedUpsell) {
        elements.stickyUpsell.textContent = '+ add-on ' + formatter.format(selectedUpsell.price / 100);
      } else {
        elements.stickyUpsell.textContent = '';
      }
    }

    function updateVariantLabel() {
      var label = currentVariant ? buildVariantLabel(currentVariant, context.optionNames) : '';
      elements.stickyVariant.textContent = label;
    }

    function updateButtons() {
      var unavailable = !currentVariant || !currentVariant.available;
      elements.addToCart.disabled = unavailable;
      elements.buyNow.disabled = unavailable;
      elements.stickyAdd.disabled = unavailable;
      elements.addToCart.textContent = unavailable ? 'Unavailable' : 'Add to Basket';
    }

    function updateOptionAvailability() {
      var optionGroups = root.querySelectorAll('[data-option-position]');

      optionGroups.forEach(function (group) {
        var position = Number(group.getAttribute('data-option-position'));
        group.querySelectorAll('[data-option-value]').forEach(function (button) {
          var testOptions = selectedOptions.slice();
          var value = button.getAttribute('data-option-value');
          var matchingVariant;

          testOptions[position] = value;
          matchingVariant = context.variants.find(function (variant) {
            return variant.options.every(function (optionValue, optionIndex) {
              return optionValue === testOptions[optionIndex];
            });
          });

          button.classList.toggle('active', selectedOptions[position] === value);
          button.classList.toggle('disabled', !matchingVariant || !matchingVariant.available);
          button.setAttribute('aria-pressed', selectedOptions[position] === value ? 'true' : 'false');
        });
      });
    }

    /* ── Color swatches with variant images ── */

    function updateColorSwatches() {
      var colorImages = context.colorImages || {};

      root.querySelectorAll('.color-option').forEach(function (button) {
        var value = button.getAttribute('data-option-value');
        var label = button.querySelector('.color-name');
        var imgSrc = colorImages[value] || '';
        var swatch = colorSwatch(value);

        if (imgSrc) {
          button.style.background = 'url(' + imgSrc + ') center/cover no-repeat';
          button.style.backgroundSize = 'cover';
          button.classList.remove('has-label');
          button.style.borderStyle = 'solid';
        } else if (swatch.type === 'hex') {
          button.style.background = swatch.value;
          button.style.backgroundSize = '';
          button.classList.remove('has-label');
        } else {
          button.style.background = 'linear-gradient(135deg, #6a5b52, #cbbca8)';
          button.style.backgroundSize = '';
          button.classList.add('has-label');
          if (label) {
            label.textContent = value;
          }
        }
      });
    }

    function updateColorNameDisplay() {
      var colorNameEl = root.querySelector('[data-selected-color-name]');
      var colorSwatchEl = root.querySelector('[data-selected-color-swatch]');
      if (!colorNameEl) return;

      var colorIdx = -1;
      context.optionNames.forEach(function (name, i) {
        if (isColorOption(name)) { colorIdx = i; }
      });

      if (colorIdx !== -1 && selectedOptions[colorIdx]) {
        colorNameEl.textContent = selectedOptions[colorIdx];
        if (colorSwatchEl) {
          var swatch = colorSwatch(selectedOptions[colorIdx]);
          if (swatch.type === 'hex') {
            colorSwatchEl.style.background = swatch.value;
            colorSwatchEl.style.display = '';
          } else {
            colorSwatchEl.style.background = 'linear-gradient(135deg, #6a5b52, #cbbca8)';
            colorSwatchEl.style.display = '';
          }
        }
      }
    }

    /* ── Gallery color filtering and navigation ── */

    function getColorOptionValues() {
      var values = [];
      (context.optionNames || []).forEach(function (name, i) {
        if (isColorOption(name)) {
          context.variants.forEach(function (v) {
            var val = v.options[i];
            if (val && values.indexOf(val) === -1) {
              values.push(val);
            }
          });
        }
      });
      return values;
    }

    function getSelectedColor() {
      var colorIdx = -1;
      (context.optionNames || []).forEach(function (name, i) {
        if (isColorOption(name)) { colorIdx = i; }
      });
      return colorIdx !== -1 ? (selectedOptions[colorIdx] || '') : '';
    }

    function filterGalleryByColor() {
      var selectedColor = getSelectedColor();
      var colorValues = getColorOptionValues();
      var thumbnails = elements.thumbnailList.querySelectorAll('.thumbnail');

      filteredMediaIds = [];

      thumbnails.forEach(function (thumb) {
        var alt = (thumb.getAttribute('data-media-alt') || '').trim();
        var mediaId = thumb.getAttribute('data-media-id');

        if (!selectedColor) {
          thumb.classList.remove('hidden-by-color');
          filteredMediaIds.push(mediaId);
          return;
        }

        var altLower = alt.toLowerCase();
        var selectedLower = selectedColor.toLowerCase();

        if (altLower === selectedLower || altLower.indexOf(selectedLower) !== -1 || selectedLower.indexOf(altLower) !== -1) {
          thumb.classList.remove('hidden-by-color');
          filteredMediaIds.push(mediaId);
          return;
        }

        var matchesAnyColor = false;
        colorValues.forEach(function (cv) {
          var cvLower = cv.toLowerCase();
          if (altLower === cvLower || altLower.indexOf(cvLower) !== -1 || cvLower.indexOf(altLower) !== -1) {
            matchesAnyColor = true;
          }
        });

        if (!matchesAnyColor) {
          thumb.classList.remove('hidden-by-color');
          filteredMediaIds.push(mediaId);
        } else {
          thumb.classList.add('hidden-by-color');
        }
      });

      currentGalleryIndex = 0;
    }

    function navigateGallery(direction) {
      if (filteredMediaIds.length <= 1) return;

      currentGalleryIndex += direction;
      if (currentGalleryIndex >= filteredMediaIds.length) currentGalleryIndex = 0;
      if (currentGalleryIndex < 0) currentGalleryIndex = filteredMediaIds.length - 1;

      updateMainImage(filteredMediaIds[currentGalleryIndex]);

      var activeThumb = elements.thumbnailList.querySelector('.thumbnail[data-media-id="' + filteredMediaIds[currentGalleryIndex] + '"]');
      if (activeThumb) {
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function syncVariant() {
      currentVariant = context.variants.find(function (variant) {
        return variant.options.every(function (optionValue, optionIndex) {
          return optionValue === selectedOptions[optionIndex];
        });
      }) || currentVariant;

      filterGalleryByColor();

      if (currentVariant) {
        elements.hiddenVariantInput.value = currentVariant.id;

        var mediaId = currentVariant.featuredMediaId;

        if (!mediaId) {
          var colorIdx = -1;
          context.optionNames.forEach(function (name, i) {
            if (isColorOption(name)) { colorIdx = i; }
          });
          if (colorIdx !== -1) {
            var colorValue = selectedOptions[colorIdx];

            // 1) Try finding a variant with same color that has featuredMediaId
            var variantWithImage = context.variants.find(function (v) {
              return v.options[colorIdx] === colorValue && v.featuredMediaId;
            });
            if (variantWithImage) {
              mediaId = variantWithImage.featuredMediaId;
            }

            // 2) Match colorImages thumbnail URL to a media item by filename
            if (!mediaId && context.colorImages && context.colorImages[colorValue]) {
              var colorThumbUrl = context.colorImages[colorValue];
              var baseName = colorThumbUrl.split('?')[0];
              var matchingMedia = context.media.find(function (m) {
                return m.src && m.src.split('?')[0] === baseName;
              });
              if (matchingMedia) {
                mediaId = matchingMedia.id;
              }
            }

            // 3) Last resort: use colorFullImages directly
            if (!mediaId && context.colorFullImages && context.colorFullImages[colorValue]) {
              var fullUrl = context.colorFullImages[colorValue];
              if (elements.mainImage) elements.mainImage.src = fullUrl;
              if (elements.stickyImage) elements.stickyImage.src = fullUrl;
              if (elements.zoomImage) elements.zoomImage.src = fullUrl;
              elements.thumbnailList.querySelectorAll('.thumbnail').forEach(function (t) {
                t.classList.remove('active');
              });
              updateBadges();
              updatePriceDisplay();
              updateVariantLabel();
              updateButtons();
              updateOptionAvailability();
              updateColorNameDisplay();
              renderMattressUpsell();
              return;
            }
          }
        }

        updateMainImage(mediaId || filteredMediaIds[0] || context.selectedMediaId);
      }

      updateBadges();
      updatePriceDisplay();
      updateVariantLabel();
      updateButtons();
      updateOptionAvailability();
      updateColorNameDisplay();
      updateTabSelections();
      renderMattressUpsell();
    }

    /* ── Mattress upsell with size matching ── */

    function renderMattressUpsell() {
      if (!elements.mattressInlineCards) return;

      var products = context.mattressProducts || [];
      if (!products.length) {
        var section = root.querySelector('[data-mattress-addon-inline]');
        if (section) section.style.display = 'none';
        return;
      }

      var selectedSize = getSelectedSize();

      // Update size label
      if (elements.mattressSizeLabelInline && selectedSize) {
        var sizeLabel = selectedSize.charAt(0).toUpperCase() + selectedSize.slice(1);
        elements.mattressSizeLabelInline.textContent = 'Available in ' + sizeLabel;
      }

      var html = '';
      var count = 0;

      products.forEach(function (mp) {
        var mpSizeIdx = findMattressSizeOptionIndex(mp);
        var matchingVariant = null;

        if (selectedSize && mpSizeIdx !== -1) {
          // Try exact match first
          matchingVariant = mp.variants.find(function (v) {
            var mpSize = (v.options[mpSizeIdx] || '').trim().toLowerCase();
            return mpSize === selectedSize;
          });
          // Fallback to partial match
          if (!matchingVariant) {
            matchingVariant = mp.variants.find(function (v) {
              var mpSize = (v.options[mpSizeIdx] || '').trim().toLowerCase();
              return mpSize.indexOf(selectedSize) !== -1 || selectedSize.indexOf(mpSize) !== -1;
            });
          }
        }

        if (!matchingVariant) {
          matchingVariant = mp.variants.find(function (v) { return v.available; });
        }

        if (!matchingVariant || !matchingVariant.available) return;

        count++;
        var isSelected = selectedUpsell && selectedUpsell.variantId === matchingVariant.id;
        var hasDiscount = matchingVariant.compareAtPrice && matchingVariant.compareAtPrice > matchingVariant.price;
        var saveAmount = hasDiscount ? matchingVariant.compareAtPrice - matchingVariant.price : 0;
        var sizeText = '';
        if (mpSizeIdx !== -1 && matchingVariant.options[mpSizeIdx]) {
          sizeText = matchingVariant.options[mpSizeIdx];
        }

        html += '<div class="inline-mattress-card' + (isSelected ? ' is-selected' : '') + '"'
          + ' data-upsell-card'
          + ' data-upsell-variant-id="' + matchingVariant.id + '"'
          + ' data-upsell-title="' + (mp.title || '').replace(/"/g, '&quot;') + '"'
          + ' data-upsell-price="' + matchingVariant.price + '">'
          + '<span class="inline-mattress-card-plus">'
          + (isSelected
            ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>'
            : '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>')
          + '</span>'
          + '<div class="inline-mattress-card-image">'
          + (mp.image ? '<img src="' + mp.image + '" alt="' + (mp.title || '').replace(/"/g, '&quot;') + '" loading="lazy" height="80" width="86">' : '')
          + '</div>'
          + '<div class="inline-mattress-card-details">'
          + '<div class="inline-mattress-card-title">' + mp.title + '</div>'
          + '<div class="inline-mattress-card-description">' + mp.description + '</div>'
          + '<div class="inline-mattress-card-pricing">'
          + '<span class="inline-mattress-price-current">' + formatter.format(matchingVariant.price / 100) + '</span>'
          + (hasDiscount ? '<span class="inline-mattress-price-was">Was ' + formatter.format(matchingVariant.compareAtPrice / 100) + '</span>' : '')
          + '</div>'
          + '<div class="inline-mattress-card-meta">'
          + (count === 1 ? '<span class="inline-mattress-badge top-match">Top Match</span>' : '')
          + (sizeText ? '<span class="inline-mattress-badge size-badge">Size: ' + sizeText + '</span>' : '')
          + (saveAmount > 0 ? '<span class="inline-mattress-save">Save ' + formatter.format(saveAmount / 100) + '</span>' : '')
          + (mp.handle ? '<a href="/products/' + mp.handle + '" class="inline-mattress-see-details" target="_blank">See details</a>' : '')
          + '</div>'
          + '</div>'
          + '</div>';
      });

      if (!html) {
        html = '<p style="text-align:center;padding:24px 16px;color:var(--text-light);font-size:0.9rem;">No matching mattresses found for the selected size.</p>';
      }

      elements.mattressInlineCards.innerHTML = html;
    }

    /* ── Premium customer reviews with slider ── */

    function renderReviews() {
      if (!elements.reviewRatingBig) {
        return;
      }

      elements.reviewRatingBig.textContent = '4.8';
      elements.reviewStarsLarge.innerHTML = starMarkup(4.8, 24);
      elements.reviewTotalCount.textContent = 'Based on 7 reviews';
      elements.reviewHighlight.textContent = 'Customers consistently praise the quality, design, and comfort of ' + product.title + '.';
      elements.reviewHighlightAuthor.textContent = 'Verified purchase reviews.';

      if (elements.reviewsList && !elements.reviewsList.children.length) {
        var reviews = [
          {
            author: 'Sarah M.',
            date: '12 Mar 2026',
            rating: 5,
            title: 'Absolutely stunning piece',
            text: 'The quality exceeded my expectations. Beautifully crafted with attention to detail. It fits perfectly in our bedroom and looks even better than the photos.',
            verified: true,
          },
          {
            author: 'James T.',
            date: '28 Feb 2026',
            rating: 5,
            title: 'Worth every penny',
            text: 'Solid construction, elegant design, and delivered right on time. The finish is flawless and it feels like a premium piece of furniture.',
            verified: true,
          },
          {
            author: 'Emily R.',
            date: '15 Feb 2026',
            rating: 5,
            title: 'Great quality, lovely finish',
            text: 'Really pleased with this purchase. The colour is exactly as shown online and the build quality is excellent. Delivery was smooth and well communicated.',
            verified: true,
          },
          {
            author: 'David K.',
            date: '3 Feb 2026',
            rating: 5,
            title: 'Outstanding craftsmanship',
            text: 'You can tell this is made with care. Every joint is tight, the surface is smooth, and it feels incredibly sturdy. Would highly recommend to anyone.',
            verified: true,
          },
          {
            author: 'Rachel P.',
            date: '20 Jan 2026',
            rating: 5,
            title: 'Transformed our room',
            text: 'This was exactly what we needed. The design is timeless and the quality speaks for itself. Friends have already asked where we got it from!',
            verified: true,
          },
          {
            author: 'Michael H.',
            date: '8 Jan 2026',
            rating: 5,
            title: 'Brilliant from start to finish',
            text: 'Easy ordering process, kept informed throughout delivery, and the product itself is superb. The materials feel premium and the finish is impeccable.',
            verified: true,
          },
          {
            author: 'Laura B.',
            date: '2 Jan 2026',
            rating: 5,
            title: 'Exceeded all expectations',
            text: 'We searched for months before finding this. The value for money is incredible and it looks far more expensive than it actually was. Couldn\u2019t be happier with our choice.',
            verified: true,
          },
        ];

        var reviewHtml = '';

        reviews.forEach(function (review) {
          reviewHtml += '<div class="review-card">'
            + '<div class="review-card-header">'
            + '<div class="review-card-stars">' + starMarkup(review.rating, 16) + '</div>'
            + '<span class="review-card-rating">' + review.rating + '.0</span>'
            + '</div>'
            + '<h4 class="review-card-title">' + review.title + '</h4>'
            + '<p class="review-card-text">' + review.text + '</p>'
            + '<div class="review-card-footer">'
            + '<div class="review-card-author">'
            + '<div class="review-card-avatar">' + review.author.charAt(0) + '</div>'
            + '<div>'
            + '<span class="review-card-name">' + review.author + '</span>'
            + '<span class="review-card-date">' + review.date + '</span>'
            + '</div>'
            + '</div>'
            + (review.verified ? '<span class="review-card-verified"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg> Verified</span>' : '')
            + '</div>'
            + '</div>';
        });

        elements.reviewsList.innerHTML = reviewHtml;
      }
    }

    function initReviewSlider() {
      var wrapper = root.querySelector('.reviews-slider-wrapper');
      var track = root.querySelector('.reviews-slider-track');
      var dotsContainer = root.querySelector('.reviews-slider-dots');
      if (!wrapper || !track) return;

      var cards = track.querySelectorAll('.review-card');
      if (!cards.length) return;

      var prevBtn = wrapper.querySelector('.reviews-slider-prev');
      var nextBtn = wrapper.querySelector('.reviews-slider-next');
      var currentIndex = 0;
      var slidesPerView = 1;

      function getSlidesPerView() {
        if (window.innerWidth >= 768) return 3;
        return 1;
      }

      function getMaxIndex() {
        return Math.max(0, cards.length - slidesPerView);
      }

      function buildDots() {
        if (!dotsContainer) return;
        var total = getMaxIndex() + 1;
        var dotsHtml = '';
        for (var d = 0; d < total; d++) {
          dotsHtml += '<button type="button" class="reviews-slider-dot' + (d === currentIndex ? ' active' : '') + '" data-slide="' + d + '"></button>';
        }
        dotsContainer.innerHTML = dotsHtml;
      }

      function goToSlide(index) {
        slidesPerView = getSlidesPerView();
        currentIndex = Math.max(0, Math.min(index, getMaxIndex()));
        var cardWidth = cards[0].offsetWidth + 24; // card width + gap
        track.style.transform = 'translateX(-' + (currentIndex * cardWidth) + 'px)';
        buildDots();
      }

      slidesPerView = getSlidesPerView();
      buildDots();

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goToSlide(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goToSlide(currentIndex + 1);
        });
      }

      if (dotsContainer) {
        dotsContainer.addEventListener('click', function (e) {
          var dot = e.target.closest('.reviews-slider-dot');
          if (!dot) return;
          goToSlide(Number(dot.getAttribute('data-slide')));
        });
      }

      window.addEventListener('resize', function () {
        goToSlide(Math.min(currentIndex, getMaxIndex()));
      });
    }

    /* ── Cart ── */

    function addItemsToCart(redirectToCheckout) {
      var items = [
        {
          id: Number(elements.hiddenVariantInput.value),
          quantity: getCurrentQuantity(),
        },
      ];
      var originalText = elements.addToCart.textContent;

      if (selectedUpsell) {
        items.push({
          id: selectedUpsell.variantId,
          quantity: getCurrentQuantity(),
        });
      }

      elements.addToCart.disabled = true;
      elements.addToCart.textContent = redirectToCheckout ? 'Redirecting...' : 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Unable to add product to cart.');
          }

          return response.json();
        })
        .then(function () {
          return updateCartBadges();
        })
        .then(function () {
          if (redirectToCheckout) {
            if (appliedDiscountCode) {
              window.location.href = '/discount/' + encodeURIComponent(appliedDiscountCode) + '?redirect=/checkout';
            } else {
              window.location.href = '/checkout';
            }
            return;
          }

          elements.addToCart.textContent = 'Added to Basket';

          // Open cart drawer if available
          if (window.StilloakCart) {
            window.StilloakCart.getCart().then(function (cart) {
              window.StilloakCart.renderCartDrawer(cart);
              window.StilloakCart.openCartDrawer();
            });
          }

          window.setTimeout(function () {
            elements.addToCart.disabled = !currentVariant.available;
            elements.addToCart.textContent = originalText;
          }, 1800);
        })
        .catch(function () {
          elements.addToCart.disabled = !currentVariant.available;
          elements.addToCart.textContent = 'Add to Basket';
        });
    }

    /* ── Option buttons ── */

    root.querySelectorAll('[data-option-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var position = Number(button.closest('[data-option-position]').getAttribute('data-option-position'));
        var value = button.getAttribute('data-option-value');

        if (button.classList.contains('disabled')) {
          return;
        }

        selectedOptions[position] = value;
        syncVariant();
      });
    });

    if (elements.thumbnailList) {
      elements.thumbnailList.addEventListener('click', function (event) {
        var thumbnail = event.target.closest('.thumbnail');

        if (!thumbnail) {
          return;
        }

        updateMainImage(thumbnail.getAttribute('data-media-id'));
      });
    }

    /* Gallery prev/next arrows */
    if (elements.galleryPrev) {
      elements.galleryPrev.addEventListener('click', function () {
        navigateGallery(-1);
      });
    }

    if (elements.galleryNext) {
      elements.galleryNext.addEventListener('click', function () {
        navigateGallery(1);
      });
    }

    /* Thumbnail slider scroll arrows */
    if (elements.thumbPrev) {
      elements.thumbPrev.addEventListener('click', function () {
        elements.thumbnailList.scrollBy({ left: -200, behavior: 'smooth' });
      });
    }

    if (elements.thumbNext) {
      elements.thumbNext.addEventListener('click', function () {
        elements.thumbnailList.scrollBy({ left: 200, behavior: 'smooth' });
      });
    }

    /* Touch swipe for main image on mobile */
    var touchStartX = 0;
    var mainImageEl = root.querySelector('.main-image');
    if (mainImageEl) {
      mainImageEl.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      mainImageEl.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) {
          navigateGallery(diff > 0 ? 1 : -1);
        }
      }, { passive: true });
    }

    if (elements.qtyDecrease) {
      elements.qtyDecrease.addEventListener('click', function () {
        elements.qtyInput.value = Math.max(1, getCurrentQuantity() - 1);
        updatePriceDisplay();
      });
    }

    if (elements.qtyIncrease) {
      elements.qtyIncrease.addEventListener('click', function () {
        elements.qtyInput.value = Math.min(10, getCurrentQuantity() + 1);
        updatePriceDisplay();
      });
    }

    if (elements.qtyInput) {
      elements.qtyInput.addEventListener('change', function () {
        elements.qtyInput.value = getCurrentQuantity();
        updatePriceDisplay();
      });
    }

    if (elements.addToCart) {
      elements.addToCart.addEventListener('click', function () {
        addItemsToCart(false);
      });
    }

    if (elements.buyNow) {
      elements.buyNow.addEventListener('click', function () {
        addItemsToCart(true);
      });
    }

    if (elements.stickyAdd) {
      elements.stickyAdd.addEventListener('click', function () {
        addItemsToCart(false);
      });
    }

    if (elements.zoomButton && elements.zoomOverlay && elements.zoomImage) {
      elements.zoomButton.addEventListener('click', function () {
        elements.zoomImage.src = elements.mainImage.src;
        elements.zoomImage.removeAttribute('srcset');
        elements.zoomImage.alt = elements.mainImage.alt;
        elements.zoomOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      });

      elements.zoomOverlay.addEventListener('click', function () {
        elements.zoomOverlay.classList.remove('active');
        document.body.style.overflow = '';
      });
    }

    if (elements.readMoreButton && elements.descFull) {
      if (!elements.descFull.textContent.trim()) {
        elements.readMoreButton.classList.add('product-page-hidden');
      }

      elements.readMoreButton.addEventListener('click', function () {
        var expanded = elements.descFull.classList.toggle('expanded');
        elements.readMoreButton.classList.toggle('expanded', expanded);
        elements.readMoreButton.childNodes[0].nodeValue = expanded ? 'Read Less ' : 'Read More ';
        var descShort = root.querySelector('.desc-short');
        if (descShort) descShort.style.display = expanded ? 'none' : '';
      });
    }

    if (elements.voucherInput) {
      elements.voucherInput.value = appliedDiscountCode;
    }

    if (elements.voucherButton) {
      elements.voucherButton.addEventListener('click', function () {
        var code = (elements.voucherInput.value || '').trim();

        if (!code) {
          elements.voucherMessage.textContent = 'Enter a voucher code to save it for checkout.';
          elements.voucherMessage.className = 'voucher-message error';
          return;
        }

        appliedDiscountCode = code;
        localStorage.setItem('stilloak_discount_code', appliedDiscountCode);
        elements.voucherMessage.textContent = 'Voucher saved. It will be applied when you continue to checkout.';
        elements.voucherMessage.className = 'voucher-message success';
      });
    }

    if (elements.wishlistButton) {
      elements.wishlistButton.addEventListener('click', function () {
        var key = 'stilloak_wishlist_handles';
        var handles = [];
        var existing = localStorage.getItem(key);

        if (existing) {
          handles = JSON.parse(existing);
        }

        if (handles.indexOf(product.handle) === -1) {
          handles.push(product.handle);
          elements.wishlistButton.classList.add('active');
        } else {
          handles = handles.filter(function (handle) {
            return handle !== product.handle;
          });
          elements.wishlistButton.classList.remove('active');
        }

        localStorage.setItem(key, JSON.stringify(handles));

        // Update header wishlist badge
        if (window.StilloakCart) {
          window.StilloakCart.updateWishlistBadge();
        }
      });

      try {
        var storedWishlist = JSON.parse(localStorage.getItem('stilloak_wishlist_handles') || '[]');
        if (storedWishlist.indexOf(product.handle) !== -1) {
          elements.wishlistButton.classList.add('active');
        }
      } catch (error) {
        // Ignore malformed local storage.
      }
    }

    if (elements.compareButton) {
      elements.compareButton.addEventListener('click', function () {
        elements.compareButton.style.borderColor = 'var(--teal)';
        elements.compareButton.style.color = 'var(--teal)';
        window.setTimeout(function () {
          elements.compareButton.style.borderColor = '';
          elements.compareButton.style.color = '';
        }, 1400);
      });
    }

    if (elements.upsellGrid) {
      elements.upsellGrid.addEventListener('click', function (event) {
        var card = event.target.closest('[data-upsell-card]');

        if (!card) {
          return;
        }

        elements.upsellGrid.querySelectorAll('[data-upsell-card]').forEach(function (item) {
          item.classList.remove('selected');
        });

        card.classList.add('selected');
        selectedUpsell = {
          variantId: Number(card.getAttribute('data-upsell-variant-id')),
          title: card.getAttribute('data-upsell-title'),
          price: Number(card.getAttribute('data-upsell-price')),
        };
        elements.selectedUpsellText.textContent = selectedUpsell.title;
        elements.selectedUpsellPrice.textContent = '+' + formatter.format(selectedUpsell.price / 100);
        updatePriceDisplay();
      });
    }

    // Inline mattress card click handler
    var inlineCardsContainer = root.querySelector('[data-mattress-inline-cards]');
    if (inlineCardsContainer) {
      inlineCardsContainer.addEventListener('click', function (event) {
        // Don't handle clicks on "See details" link
        if (event.target.closest('.inline-mattress-see-details')) return;

        var card = event.target.closest('[data-upsell-card]');
        if (!card) return;

        var wasSelected = card.classList.contains('is-selected');

        // Deselect all
        inlineCardsContainer.querySelectorAll('[data-upsell-card]').forEach(function (item) {
          item.classList.remove('is-selected');
          var plus = item.querySelector('.inline-mattress-card-plus');
          if (plus) {
            plus.innerHTML = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>';
          }
        });

        if (wasSelected) {
          // Deselect
          selectedUpsell = null;
          if (elements.mattressInlineFooter) elements.mattressInlineFooter.style.display = 'none';
          if (elements.stickyUpsell) elements.stickyUpsell.textContent = '';
        } else {
          // Select this card
          card.classList.add('is-selected');
          var plusIcon = card.querySelector('.inline-mattress-card-plus');
          if (plusIcon) {
            plusIcon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>';
          }
          selectedUpsell = {
            variantId: Number(card.getAttribute('data-upsell-variant-id')),
            title: card.getAttribute('data-upsell-title'),
            price: Number(card.getAttribute('data-upsell-price')),
          };
          if (elements.mattressInlineFooter) elements.mattressInlineFooter.style.display = '';
          if (elements.mattressSelectedName) elements.mattressSelectedName.textContent = selectedUpsell.title;
          if (elements.mattressSelectedPrice) elements.mattressSelectedPrice.textContent = '+' + formatter.format(selectedUpsell.price / 100);
        }

        updatePriceDisplay();
        renderMattressUpsell(); // Re-render to update selection state
      });
    }

    if (elements.clearUpsell) {
      elements.clearUpsell.addEventListener('click', function () {
        selectedUpsell = null;
        if (elements.upsellGrid) {
          elements.upsellGrid.querySelectorAll('[data-upsell-card]').forEach(function (item) {
            item.classList.remove('selected');
          });
        }
        elements.selectedUpsellText.textContent = 'None';
        elements.selectedUpsellPrice.textContent = '+' + formatter.format(0);
        updatePriceDisplay();
      });
    }

    /* ── Addon Sidebar ── */
    /* Sidebar removed - now using inline mattress cards */

    window.addEventListener('scroll', function () {
      var productTop = root.querySelector('[data-product-top]');
      var rect;

      if (!productTop || !elements.stickyPurchase) {
        return;
      }

      rect = productTop.getBoundingClientRect();
      elements.stickyPurchase.classList.toggle('visible', rect.bottom < 0);
    }, { passive: true });

    if (elements.stars) {
      if (context.ratingValue > 0) {
        elements.stars.innerHTML = starMarkup(context.ratingValue, 18);
        elements.ratingValue.textContent = Number(context.ratingValue).toFixed(1);
        elements.reviewCount.textContent = '(' + context.ratingCount + ' reviews)';
      } else {
        elements.stars.innerHTML = '';
        elements.ratingValue.textContent = 'New';
        elements.reviewCount.textContent = 'Be the first to review';
      }
    }

    updateColorSwatches();
    filterGalleryByColor();

    /* ── Variant Tabs ── */

    var tabContainer = root.querySelector('[data-variant-tabs]');
    var tabButtons = tabContainer ? tabContainer.querySelectorAll('[data-tab-index]') : [];
    var tabPanels = tabContainer ? tabContainer.querySelectorAll('[data-tab-panel]') : [];

    function activateInitialPanel() {
      if (!tabContainer) return;
      var hasActive = tabContainer.querySelector('.variant-tab-panel.active:not(.product-page-hidden)');
      if (!hasActive) {
        var firstVisible = tabContainer.querySelector('.variant-tab-panel:not(.product-page-hidden)');
        if (firstVisible) firstVisible.classList.add('active');
      }
    }

    function updateTabSelections() {
      if (!tabContainer) return;
      context.optionNames.forEach(function (name, i) {
        var el = tabContainer.querySelector('[data-tab-selection="' + i + '"]');
        if (el && selectedOptions[i]) {
          el.textContent = selectedOptions[i];
        }
      });
    }

    activateInitialPanel();

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.getAttribute('data-tab-index');
        tabButtons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        tabPanels.forEach(function (panel) {
          panel.classList.remove('active');
          if (panel.getAttribute('data-tab-panel') === idx) {
            panel.classList.add('active');
          }
        });
      });
    });

    // On initial load, always use the first filtered image
    var initialMediaId = filteredMediaIds.length > 0 ? filteredMediaIds[0] : (context.selectedMediaId || '');
    updateMainImage(initialMediaId);

    // Preload all full-size images in background for instant switching
    preloadAllMedia();

    updateBadges();
    updatePriceDisplay();
    updateVariantLabel();
    updateButtons();
    updateOptionAvailability();
    updateColorNameDisplay();
    renderMattressUpsell();
    renderReviews();
    updateCartBadges();
    initProductCarousels();
    initInfoAccordion();
  });

  function initInfoAccordion() {
    var accordion = document.querySelector('[data-product-info-accordion]');
    if (accordion) {
      var triggers = accordion.querySelectorAll('[data-info-accordion-trigger]');
      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var item = trigger.closest('.info-accordion-item');
          var body = item ? item.querySelector('[data-info-accordion-body]') : null;
          if (!body) return;

          var isActive = trigger.classList.contains('active');
          trigger.classList.toggle('active', !isActive);
          body.classList.toggle('active', !isActive);
        });
      });
    }

    // Mattress addon accordion
    var mattressTrigger = document.querySelector('[data-mattress-accordion-trigger]');
    if (mattressTrigger) {
      mattressTrigger.addEventListener('click', function () {
        var section = mattressTrigger.closest('[data-mattress-addon-inline]');
        if (section) {
          section.classList.toggle('is-open');
        }
      });
    }
  }

  function initProductCarousels() {
    if (window.innerWidth >= 768) return;

    var carousels = [
      { grid: '.features-list', item: '.feature-item' },
      { grid: '.delivery-grid', item: '.delivery-card' },
      { grid: '.process-steps', item: '.process-step' }
    ];

    carousels.forEach(function (cfg) {
      var grid = document.querySelector(cfg.grid);
      if (!grid || grid.dataset.carousel === 'true') return;
      var items = grid.querySelectorAll(cfg.item);
      if (items.length <= 1) return;

      grid.dataset.carousel = 'true';

      var wrapper = document.createElement('div');
      wrapper.className = 'mobile-carousel-wrapper';
      grid.parentNode.insertBefore(wrapper, grid);
      wrapper.appendChild(grid);

      var dots = document.createElement('div');
      dots.className = 'carousel-dots';
      for (var i = 0; i < items.length; i++) {
        var dot = document.createElement('button');
        dot.className = 'carousel-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.dataset.index = i;
        (function (idx) {
          dot.addEventListener('click', function () {
            items[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          });
        })(i);
        dots.appendChild(dot);
      }
      wrapper.appendChild(dots);

      var allDots = dots.querySelectorAll('.carousel-dot');
      grid.addEventListener('scroll', function () {
        var scrollLeft = grid.scrollLeft;
        var gap = parseFloat(getComputedStyle(grid).gap) || 0;
        var itemWidth = items[0].offsetWidth + gap;
        var activeIdx = Math.round(scrollLeft / itemWidth);
        if (activeIdx >= allDots.length) activeIdx = allDots.length - 1;
        allDots.forEach(function (d, idx) {
          d.classList.toggle('active', idx === activeIdx);
        });
      }, { passive: true });
    });
  }
})();
